import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useGetCart } from '../../hooks/use-get-cart.js';
import { CartContext } from './context.js';

var CartProvider = (_param)=>{
    var { children  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "children"
    ]);
    const { cartCount , cartHash , cartId , onUnrecoverableErrors , onUpdateCartLocaleState , onFinalisedCartError , onCartDataLoadedSuccessfully ,  } = rest;
    const { called , refetch , loading , data , error , fetchByCartId  } = useGetCart({
        cartCount,
        cartHash,
        cartId,
        onUnrecoverableErrors,
        onUpdateCartLocaleState,
        onFinalisedCartError,
        onCartDataLoadedSuccessfully
    });
    const value = React.useMemo(()=>({
            cart: data,
            refetch,
            loading,
            error,
            called,
            fetchByCartId
        })
    , [
        data,
        refetch,
        called,
        loading,
        error,
        fetchByCartId
    ]);
    if (typeof children === 'function') {
        return /*#__PURE__*/ React.createElement(CartContext.Provider, {
            value: value
        }, children(value));
    }
    return /*#__PURE__*/ React.createElement(CartContext.Provider, {
        value: value
    }, children);
};

export { CartProvider };
//# sourceMappingURL=provider.js.map
